// features/drive/components/Explorer/Explorer.styles.js

import styled from 'styled-components';

export const ExplorerWrapper = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.landing.cardBg};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-radius: ${({ theme }) => theme.landingBorderRadius.lg};
  overflow: hidden;
`;

export const ExplorerHeader = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid ${({ theme }) => theme.landing.cardBorder};

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const ExplorerBody = styled.div`
  min-height: 400px;
  max-height: calc(100vh - 250px);
  overflow-y: auto;
`;
